export default class NumistaAPI {
  static async getDetails(id) {
    return fetch(`https://qmegas.info/numista-api/coin/${id}`)
      .then((res) => res.json());
  }

  static async search(countryId, page) {
    if (!page) {
      page = 1;
    }
    return fetch(`https://qmegas.info/numista-api/country/${countryId}/coins?filter_euro=1&limit=100&page=${page}`)
      .then((response) => response.json());
  }

  static async getPrice(coinId) {
    return fetch(`https://qmegas.info/numista-api/coin/prices?coin_id=${coinId}`)
      .then((response) => response.json());
  }
}
